import { Component, ElementRef, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, AlertController, Events, ViewController } from 'ionic-angular';
import { RestProvider } from '../../providers/rest/rest';

import { QrHelperProvider } from '../../providers/qr-helper/qr-helper';
import { UploadHelperProvider } from '../../providers/upload-helper/upload-helper';
import { ToastHelperProvider } from '../../providers/toast-helper/toast-helper';

import { IntervalObservable } from "rxjs/observable/IntervalObservable";
import 'rxjs/add/operator/filter';

/**
 * Generated class for the LotDetailPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

// @IonicPage()
@Component({
  selector: 'page-lot-detail',
  templateUrl: 'lot-detail.html',
})
export class LotDetailPage {
  @ViewChild('cameraInput') cameraInput: ElementRef;
  @ViewChild('galleryInput') galleryInput: ElementRef;
  public data: any = null;
  public changedFromObs:boolean = false;
  public loading;
  public errorMessage;
  public hasPrice:boolean = false;
  public dataLoaded: boolean = false;
  private lastImage: string = null;
  private lotId: number = null;
  private paidToggleDisabled: boolean = false;
  public scanEventName = 'addCient:scanned';
  public hideContent: boolean = false;
  public changedPaidManually: boolean = false;
  public failedRequest: boolean = false;
  public deleteTimer = null;
  public _scanEventFunction;
  public init: boolean = false;
  public watchObs: boolean = true;
  public subscribed: boolean = false;
  public lastPaidStatus: any = null;
  public spinnerTime: any = null;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public loadingCtrl: LoadingController,
              public alertCtrl: AlertController,
              public events: Events,
              private qrHelper: QrHelperProvider,
              private uploadHelper: UploadHelperProvider,
              private rest: RestProvider,
              private toastHelper: ToastHelperProvider,
              private viewCtrl: ViewController) {
    this.lotId = this.navParams.get('id');
    this.getLotData();
  }

  //lifecycle events
  ionViewWillEnter(){
    this.watchObs = true;
    this.scanEventName += this.navCtrl.getPrevious().name; //add name for qr/lotlist?
    this._scanEventFunction = text => {this.codeFound(text);}
    this.events.subscribe(this.scanEventName, this._scanEventFunction);
    if (this.init) {
      this.lotId = this.navParams.get('id');
      this.getLotData();
    }
    this.init = true
  }

  ionViewWillLeave(){
    this.watchObs = false;
    if (this.hideContent) {
      this.cancelScan();
    }
    this.events.unsubscribe(this.scanEventName, this._scanEventFunction);
  }

  clickedImage(index){
    let imgWrapper:HTMLElement = document.querySelector("[data-imgindex='" + index + "']");
    if (imgWrapper.classList.contains('active')) {
      this.watchObs = false;
      let alert = this.alertCtrl.create({
        title: 'Afbeelding verwijderen',
        message: 'Ben je zeker dat je deze afbeelding wilt verwijderen?',
        buttons: [
          {
            text: 'Annuleer',
            role: 'cancel',
            handler: () => {
              this.watchObs = true;
              this.toastHelper.showToast('Verwijderen geannuleerd.');
              imgWrapper.classList.remove('active');
              this.hideLoading();
            }
          },
          {
            text: 'Bevestigen',
            handler: () => {
              this.watchObs = true;
              this.removeImg(imgWrapper);
            }
          }
        ]
      });
      alert.present();
    }else{
      this.removeImgActiveStates();
      imgWrapper.classList.add('active');
      if (this.deleteTimer != null) {
        clearTimeout(this.deleteTimer);
      }
      this.deleteTimer = setTimeout(function(){
        if (imgWrapper.classList.contains('active')){
          imgWrapper.classList.remove('active');
        };
      }, 2000);
    }
  }

  removeImg(imgWrapper){
    clearTimeout(this.deleteTimer);
    this.deleteTimer = null;
    if (!this.rest.checkConnection()) {
      this.presentNoConnectionAlert(this.removeImg.bind(this, imgWrapper));
      return;
    }
    this.removeImgActiveStates();
    let imgId = imgWrapper.dataset.imgid;
    let imgUrl = imgWrapper.dataset.imgurl;
    
    this.rest.removeImageById(imgId).subscribe((success) => {
      if (success) {
        //remove from array
        let imgObjectIndex = this.data.imgs.indexOf(this.data.imgs.find(o => o['id'] == imgId));
        if (imgObjectIndex > -1) {
          this.data.imgs.splice(imgObjectIndex, 1);
        }
        //remove from view
        imgWrapper.parentElement.remove();
        this.toastHelper.showToast('Afbeelding verwijderd.');
      }else{
        this.toastHelper.showToast('ERROR: Kon de afbeelding niet verwijderen.', 'error');
      }
      this.hideLoading();
    }, error => {
      this.toastHelper.showToast('ERROR: Fout tijdens het versturen naar de server.', 'error');
      this.hideLoading();
    });
  }

  removeImgActiveStates(){
    let actives = document.querySelectorAll(".img-wrapper.active");
    for (var i = 0; i < actives.length; ++i) {
      actives[i].classList.remove('active');
    }
  }

  public buyerClicked(add){
    if (add) {
      this.scanBuyer();
    }else{
      //alert before delete
      this.watchObs = false;
      let alert = this.alertCtrl.create({
        title: 'Verwijder koper',
        message: 'Ben je zeker dat je deze koper wilt verwijderen?',
        buttons: [
          {
            text: 'Cancel',
            role: 'cancel',
            handler: () => {
              this.toastHelper.showToast('Koper is ongewijzigd gebleven.');
              this.watchObs = true;
            }
          },
          {
            text: 'Verwijder',
            handler: () => {
              this.removeBuyer();
              this.watchObs = true;
            }
          }
        ]
      });
      alert.present();
    }
  }

  public removeBuyer(fromCb = false){
    if (!fromCb) {
      this.showLoading('Koper wordt verwijderd');
    }
    if (!this.rest.checkConnection()) {
      this.presentNoConnectionAlert(this.removeBuyer.bind(this,true));
      return;
    }
    this.rest.removeBuyer(this.data.id).subscribe((success) => {
      if (success) {
        this.data.buyer = '';
        this.data.buyerId = null;
        this.toastHelper.showToast('Koper verwijderd.');
      }else{
        this.toastHelper.showToast('ERROR: Kon de status niet op  ' + status + ' zetten.', 'error');
      }
      this.hideLoading();
    }, error => {
      this.toastHelper.showToast('ERROR: Fout tijdens het versturen naar de server.', 'error');
      this.hideLoading();
    });
  }

  public paidStatusChanged($event){ //value
    if (!this.data.paid && !this.changedPaidManually && !this.changedFromObs) {
      this.watchObs = false;
      let alert = this.alertCtrl.create({
        title: 'Verwijder betaalstatus',
        message: 'Ben je zeker dat je dit lot terug op "niet betaald" wilt zetten?',
        buttons: [
          {
            text: 'Annuleer',
            role: 'cancel',
            handler: () => {
              this.watchObs = true;
              this.data.paid = true;
              this.changedPaidManually = true;
              this.toastHelper.showToast('Betaalstatus is ongewijzigd gebleven.');
            }
          },
          {
            text: 'Ja',
            handler: () => {
              this.watchObs = true;
              this.paidToggleDisabled = true;
              this.showLoading('Betaal status wordt geüpdate...');
              this.sendPaidStatus()
            }
          }
        ]
      });
      alert.present();
    }else{
      if (this.changedPaidManually || this.changedFromObs) {
        if (this.changedPaidManually) {
          this.changedPaidManually = false;
        }
        if (this.changedFromObs) {
          this.changedFromObs = false;
        }
      }else{
        this.paidToggleDisabled = true;
        this.showLoading('Betaal status wordt geüpdate...');
        this.sendPaidStatus()
      }
    }
  }

  public sendPaidStatus(){
    if (!this.rest.checkConnection()) {
      this.presentNoConnectionAlert(this.sendPaidStatus.bind(this),this.cancelPaidChange.bind(this));
      return;
    }
    let status = '"betaald"';
    if (!this.data.paid) {
      status = '"niet betaald"';
    }
    this.rest.setPaidStatus(this.data.id, this.data.paid).subscribe((success) => {
      this.hideLoading();
      if (success) {
        this.toastHelper.showToast('Status ' + status + ' opgeslagen.');
        this.paidToggleDisabled = false;
      }else{
        this.toastHelper.showToast('ERROR: Kon de status niet op  ' + status + ' zetten.', 'error');
        this.cancelPaidChange();
      }
    }, error => {
      this.hideLoading();
      this.toastHelper.showToast('ERROR: Fout tijdens het versturen naar de server.', 'error');
      this.cancelPaidChange();
    });
  }

  cancelPaidChange(){
    this.changedPaidManually = true;
    this.data.paid = !this.data.paid;
    this.paidToggleDisabled = false;
  }

  public getLotData(fromCb = false) {
    if (!fromCb) {
      this.showLoading('Ophalen van lot data...');
    }
    if (!this.rest.checkConnection()) {
      this.presentNoConnectionAlert(this.getLotData.bind(this,true));
      return;
    }
    this.rest.getLot(this.lotId).subscribe(data => this.processObservable(data)
      , error => {
      this.failedRequest = true;
      this.hideLoading();
      this.toastHelper.showToast('ERROR: Kon de lot data niet ophalen.', 'error');
    });
    if (!this.subscribed) {
      this.subscribed = true;
      IntervalObservable.create(5000)
      .filter(() => this.watchObs) // only fires when component is watchObs
      .subscribe(() => {
        this.spinnerTime = performance.now();
        this.updateLoadingSpinner(true);
        this.rest.getLot(this.lotId)
          .subscribe(data => this.processObservable(data), error => this.toastHelper.showToast('ERROR: Kon de lot data niet updaten.', 'error'));
      });
    }
  }

  updateLoadingSpinner(show){
    let spinner = document.querySelector('ion-tab[aria-hidden="false"] page-lot-detail .loading-spinner');
    if (show) {
      if(!spinner.classList.contains('active')){
        spinner.classList.add('active')
      }
    }else{
      let timeSpend = performance.now() - this.spinnerTime;
      if (timeSpend < 1000) {
        setTimeout(function(){
          if(spinner.classList.contains('active')){
            spinner.classList.remove('active')
          }  
        },1000 - timeSpend);
      }else{
        if(spinner.classList.contains('active')){
          spinner.classList.remove('active')
        }  
      }
      
    }
  }

  processObservable(lot){
    if (lot) {
      let parsedData = JSON.parse(String(lot));
      console.log(parsedData);
      if (this.data != null) {
        //compare changes online and app + show toast if changed
        let changes = [];
        if (this.data.nr != parsedData.nr) {
          changes.push('Lot nr');
        }
        if (this.data.price != parsedData.price) {
          changes.push('Prijs');
        }
        if (this.data.description != parsedData.description) {
          changes.push('Omschrijving');
        }
        if (!this.compareImgArrays(this.data.imgs, parsedData.imgs)){
          changes.push('Afbeeldingen');
        }
        if (this.data.buyer != parsedData.buyer) {
          changes.push('Koper');
        }
        if (this.data.paid != parsedData.paid) {
          changes.push('Betaal status');
        }
        if (this.data.pickedUp != parsedData.pickedUp) {
          changes.push('Afgehaald status');
        }
        if (this.data.auctionRunning != parsedData.auctionRunning) {
          changes.push('De verkoop gaat starten');
        }
        if (changes.length > 0) {
          this.changedFromObs = true;
          this.toastHelper.showToast(changes.join(', ') + ' geüpdate via de site.');
        }else{
          this.changedFromObs = false;
        }
      }
      //set data
      this.failedRequest = false;
      this.data = parsedData;
      this.dataLoaded = true;
      this.hideLoading();
      if (this.data['price'] > 0) {
        this.hasPrice = true;
      }else{
        this.hasPrice = false;
      } 
    }else{
      this.failedRequest = true;
      this.hideLoading();
      this.toastHelper.showToast('ERROR: Kon de lot data niet ophalen.', 'error');
    }
    this.updateLoadingSpinner(false);
  }

  //add buyer...
  scanBuyer(){
    this.hideContent = true;
    this.watchObs = false;
    this.qrHelper.startQr(this.scanEventName, 'qr-reader-buyer');
    this.viewCtrl.showBackButton(false);
  }

  cancelScan(){
    this.hideContent = false;
    this.watchObs = true;
    this.qrHelper.destroyQr();
    this.viewCtrl.showBackButton(true);
  }

  codeFound(text:string) {
    this.hideContent = false;
    // if (!this.IsJsonString(text)) {
    //   let passKey = 'The Craft NV Is gelegen te Melle op de Brusselsestraat 197. Ze hebben dit project voor VGGO gemaakt.';
    //   text = GibberishAES.dec(text, passKey);
    // }
    // if (!this.IsJsonString(text)) {
    //   this.toastHelper.showToast('ERROR: Onbekende QR code.', 'error');
    //   return;
    // }
    let qrObj = JSON.parse(text);
    if (typeof(qrObj) === 'object' && 'section' in qrObj) {
        if(qrObj['section'] == 'contacts'){
          if ('entryId' in qrObj) {
            this.toastHelper.showToast('QR code gevonden.');
            this.showLoading('Opslaan van koper...');
            this.setBuyer(qrObj['entryId']); //will put watchObs true later on
          }else{
            this.toastHelper.showToast('ERROR: Kon de user niet afleiden uit de qr code.', 'error');
            this.watchObs = true;
          }
        }else{
          this.toastHelper.showToast('ERROR: QR code is niet van een klant maar van: ' + qrObj['section'] + '.', 'error');
          this.watchObs = true;
        }
    }else{
      this.toastHelper.showToast('ERROR: Onbekende QR code.', 'error');
      this.watchObs = true;
    }
  }

  private IsJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  public setBuyer(buyerId){
    if (!this.uploadHelper.checkConnection()) {
      this.presentNoConnectionAlert(this.setBuyer.bind(this, buyerId));
      return;
    }
    this.rest.setBuyer(this.data.id, buyerId).subscribe((success) => {
      if (success) {
        //todo set data
        this.data.buyer = success.name;
        this.data.buyerId = success.id;
        this.toastHelper.showToast('Koper toegevoegd.');
      }else{
        this.toastHelper.showToast('ERROR: Kon de koper niet toevoegen.', 'error');
      }
      this.hideLoading();
    }, error => {
      this.toastHelper.showToast('ERROR: Fout tijdens het versturen naar de server.', 'error');
      this.hideLoading();
    });
  }

  //images...
  public takePicture(cameraRoll = false) {
    this.watchObs = false;
    if (cameraRoll) {
      this.galleryInput.nativeElement.value = '';
      this.galleryInput.nativeElement.click();
    } else {
      this.cameraInput.nativeElement.value = '';
      this.cameraInput.nativeElement.click();
    }
  }

  public onPhotoSelected(event) {
    const file: File = event.target.files[0];
    if (file) {
      this.showLoading('Opslaan van afbeelding...');
      this.uploadImg(file);
    } else {
      this.watchObs = true;
    }
  }

  uploadImg(imageFile: File) {
    if (!this.uploadHelper.checkConnection()) {
      this.presentNoConnectionAlert(this.uploadImg.bind(this, imageFile));
      return;
    }
    this.uploadHelper.uploadFile(this.data.id, imageFile).then(success => {
      console.log('uploadImg response', success);
      if (success) {
        let parsed: any = null;
        try { parsed = JSON.parse(success['response']); } catch(e) {}
        if (success['responseCode'] == 200 && parsed) {
          this.data = parsed;
          if (this.data['price'] > 0) {
            this.hasPrice = true;
          }else{
            this.hasPrice = false;
          }
          this.toastHelper.showToast('Afbeelding toegevoegd.');
        }else{
          this.toastHelper.showToast('ERROR: Fout bij het opslaan. (code: '+ success['responseCode'] + ', antwoord: ' + success['response'] + ')', 'error');
        }
      }else{
        this.toastHelper.showToast('ERROR: Fout bij het uploaden van de afbeelding.', 'error');
      }
      this.hideLoading();
    }, err => {
      this.hideLoading();
      this.toastHelper.showToast('ERROR: Fout bij het opslaan: ' + err + '.', 'error');
    });
  }

  doRefresh($event){
    if (!this.rest.checkConnection()) {
      this.toastHelper.showToast('ERROR: kon geen verbinding maken', 'error');
      $event.complete();
    }else{
      var that = this;
      let promise = new Promise(function(resolve, reject) {
        that.rest.getLot(that.lotId).subscribe(
          function(data){
            resolve(data);
          }, error => {
            reject('err');
        });      
      });
      promise.then((data) => {
        that.processObservable(data);
        that.toastHelper.showToast('Lot opgehaald');
        $event.complete();
      }).catch((err) => {
        that.failedRequest = true;
        that.toastHelper.showToast('ERROR: kon het lot niet ophalen.', 'error');
        $event.complete();
      });
    }  
  }
  
  //messages
  showLoading(msg){
    this.watchObs = false;
    this.loading = this.loadingCtrl.create({
      content: msg
    });
    this.loading.present();
  }

  hideLoading(){
    this.watchObs = true;
    if (this.loading != null) {
      this.loading.dismiss();
    }
    this.loading = null;
  }

  presentNoConnectionAlert(retryCb, cancelCb = null){
    let alert = this.alertCtrl.create({
      title: 'Geen internet',
      message: 'Kon geen verbinding maken',
      buttons: [
        {
          text: 'Annuleer',
          role: 'cancel',
          handler: () => {
            this.toastHelper.showToast('ERROR: Geen internetverbinding gevonden.', 'error');
            if (cancelCb != null) {
              cancelCb();
            }
            this.hideLoading();
          }
        },
        {
          text: 'Probeer opnieuw',
          handler: () => {
            retryCb();
          }
        }
      ]
    });
    alert.present();
  }

  compareImgArrays(a, b){ //return true = no diff
    if (a.length != b.length) {
      return false;
    }
    for (var i = 0; i < a.length; i++) {
      if (!this.compareObjects(a[i], b[i])) {
        return false
      }
    }
    return true;
  }

  compareObjects(a, b) {
    // Create arrays of property names
    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);
    // If number of properties is different,
    // objects are not equivalent
    if (aProps.length != bProps.length) {
        return false;
    }
    for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];
        // If values of same property are not equal,
        // objects are not equivalent
        if (a[propName] !== b[propName]) {
            return false;
        }
    }
    // If we made it this far, objects
    // are considered equivalent
    return true;
  }
}




// WEBPACK FOOTER //
// ./src/pages/lot-detail/lot-detail.ts